import React from 'react';
import {Button, Table} from "antd";
import {Root, Title, TitleWrapper} from "./styled";
import {columns} from "./constant";
import {useDashboardContext} from "contexts/DashboardProvider";

const RecentSales = () => {

  const { state, navigate } = useDashboardContext()

  return (
    <Root>
      <TitleWrapper>
        <Title>Recent Sales</Title>
        <Button onClick={() => navigate('/admin/sales')}>
          View All
        </Button>
      </TitleWrapper>
      <Table
        size={"middle"}
        columns={columns}
        dataSource={state.recent_sales.map((item, i) => {
          return {
            ...item,
            key: i
          }
        })}
        pagination={false}
        loading={state.is_loading_recent_sales}
      />
    </Root>
  )
};
export default RecentSales;
